import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlAccount extends Layout {
    panelAccountSection: Panel;
    sourceMCControl: DataSource;
    textboxAccountName: Textbox;
    textboxAccountNumber: Textbox;
    textboxClientId: Textbox;
    textboxControlPasswd: Textbox;
}
